import React from "react";

import "./Disclosure.css";

const Disclosure = (props) => (
  <div className={"purchase-text"}>
    <br />
    <div className={"purchase-header"}>
      <p className={"purchase-aggregate-header"}>SAR Risk Tool Subscription Request </p>
    </div>

    <div className={"purchase-body"}>
      <div className={"purchase-section"}>
        <div>
          You currently do not have a SAR Risk Tool Subscription and may not
          license a SAR Risk Report for this company. Please contact SAR
          directly at 202-436-9994 or e-mail us at info@sarlit.com to learn
          about our Corporate Risk Tool Subscription to license SAR Risk
          Reports.
        </div>
      </div>
    </div>
    <br />
  </div>
);

export default Disclosure;



// WEBPACK FOOTER //
// ./src/ace/Disclosure.js